import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Header.png'
import _imports_1 from '@/assets/deskimg.png'
import _imports_2 from '@/assets/scroll.png'
import _imports_3 from '@/assets/vejanatal.png'
import _imports_4 from '@/assets/Comofunciona.png'
import _imports_5 from '@/assets/Comofunciona_m.png'
import _imports_6 from '@/assets/textnosso.png'
import _imports_7 from '@/assets/galeria.png'
import _imports_8 from '@/assets/setal.png'
import _imports_9 from '@/assets/setar.png'


const _withScopeId = n => (_pushScopeId("data-v-1c0c915e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-1c0c915e><div class=\"mob d-flex d-md-none\" data-v-1c0c915e><img src=\"" + _imports_0 + "\" data-v-1c0c915e></div><div class=\"container d-none d-md-flex\" data-v-1c0c915e><div class=\"row\" data-v-1c0c915e><div class=\"col-12\" data-v-1c0c915e><img src=\"" + _imports_1 + "\" data-v-1c0c915e></div><div class=\"col-12 mt-2\" data-v-1c0c915e><a class=\"querodoar\" href=\"https://alegriadeviver.colabore.org/CACCC/ \" target=\"_blank\" data-v-1c0c915e>Quero doar</a></div></div></div><div class=\"scroll d-none d-md-flex\" data-v-1c0c915e><img src=\"" + _imports_2 + "\" data-v-1c0c915e></div></div>", 1)
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "row pt-5",
    "data-v-aad63f14": ""
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-5 col-12",
      id: "video",
      "data-v-aad63f14": ""
    }, [
      /*#__PURE__*/_createElementVNode("iframe", {
        width: "100%",
        height: "415",
        src: "https://www.youtube.com/embed/M2vhMnb5ddo",
        title: "YouTube video player",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: "",
        "data-v-aad63f14": ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 col-12 mt-5",
      "data-v-aad63f14": ""
    }, [
      /*#__PURE__*/_createElementVNode("iframe", {
        width: "100%",
        height: "415",
        src: "https://www.youtube.com/embed/OGpRyHoGUIQ",
        title: "YouTube video player",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: "",
        "data-v-aad63f14": ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-12 text-center d-none",
      "data-v-aad63f14": ""
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "d-md-none",
        src: _imports_3,
        "data-v-aad63f14": ""
      })
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"como d-none d-md-flex\" data-v-1c0c915e><img src=\"" + _imports_4 + "\" data-v-1c0c915e></div><div class=\"como d-flex d-md-none\" data-v-1c0c915e><img src=\"" + _imports_5 + "\" data-v-1c0c915e></div><div class=\"doacao mx-4\" data-v-1c0c915e><h1 class=\"text-center mb-5 mitr\" data-v-1c0c915e><small data-v-1c0c915e>Você</small> escolhe como e com quanto pode<small data-v-1c0c915e> ajudar!</small></h1><div class=\"row listItens\" data-v-1c0c915e><div class=\"col-md-2 col-12 offset-md-1\" data-v-1c0c915e><a href=\"https://alegriadeviver.colabore.org/CACCC/ \" data-v-1c0c915e><div class=\"boxitem green\" data-v-1c0c915e><h2 class=\"m-0\" data-v-1c0c915e><small data-v-1c0c915e>R$</small>60</h2><h3 class=\"m-0\" data-v-1c0c915e>por mês</h3></div></a></div><div class=\"col-md-2 col-12\" data-v-1c0c915e><a href=\"https://alegriadeviver.colabore.org/CACCC/ \" data-v-1c0c915e><div class=\"boxitem blue\" data-v-1c0c915e><h2 class=\"m-0\" data-v-1c0c915e><small data-v-1c0c915e>R$</small>80</h2><h3 class=\"m-0\" data-v-1c0c915e>por mês</h3></div></a></div><div class=\"col-md-2 col-12\" data-v-1c0c915e><a href=\"https://alegriadeviver.colabore.org/CACCC/ \" data-v-1c0c915e><div class=\"boxitem yellow\" data-v-1c0c915e><h2 class=\"m-0\" data-v-1c0c915e><small data-v-1c0c915e>R$</small>100</h2><h3 class=\"m-0\" data-v-1c0c915e>por mês</h3></div></a></div><div class=\"col-md-2 col-12\" data-v-1c0c915e><a href=\"https://alegriadeviver.colabore.org/CACCC/ \" data-v-1c0c915e><div class=\"boxitem purple\" data-v-1c0c915e><h2 class=\"m-0\" data-v-1c0c915e><small data-v-1c0c915e>R$</small>120</h2><h3 class=\"m-0\" data-v-1c0c915e>por mês</h3></div></a></div><div class=\"col-md-2 col-12\" data-v-1c0c915e><a href=\"https://alegriadeviver.colabore.org/CACCC/ \" data-v-1c0c915e><div class=\"boxitem pink\" data-v-1c0c915e><h2 class=\"m-0\" data-v-1c0c915e><small data-v-1c0c915e>R$</small>140</h2><h3 class=\"m-0\" data-v-1c0c915e>por mês</h3></div></a></div></div></div><div class=\"container py-4 my-5\" data-v-1c0c915e><div class=\"row px-5\" data-v-1c0c915e><div class=\"col-12 text\" data-v-1c0c915e><img class=\"w-100\" src=\"" + _imports_6 + "\" data-v-1c0c915e></div></div></div>", 4)
const _hoisted_8 = { class: "container py-4 mt-5" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row px-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text mb-5" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_7 })
  ])
], -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "col-10 galeria big p-0" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_9 }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "offset-md-1 col-md-10 col-12 flex" }
const _hoisted_19 = { class: "row my-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/2.jpg" })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/3.jpg" })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/4.jpg" })
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/5.jpg" })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/6.jpg" })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/7.jpg" })
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/8.jpg" })
], -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/9.jpg" })
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/10.jpg" })
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/11.jpg" })
], -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/12.jpg" })
], -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "galeria mini" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "fotos/13.jpg" })
], -1))
const _hoisted_43 = [
  _hoisted_42
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: "col-1 d-flex align-items-center justify-content-center",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
        }, _hoisted_12),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("img", { src: _ctx.imageurl }, null, 8, _hoisted_14)
        ]),
        _createElementVNode("div", {
          class: "col-1 d-flex align-items-center justify-content-center",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
        }, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setImage(2)))
            }, _hoisted_21),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setImage(3)))
            }, _hoisted_23),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setImage(4)))
            }, _hoisted_25),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setImage(5)))
            }, _hoisted_27),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setImage(6)))
            }, _hoisted_29),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setImage(7)))
            }, _hoisted_31),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setImage(2)))
            }, _hoisted_33),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setImage(3)))
            }, _hoisted_35),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setImage(4)))
            }, _hoisted_37),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setImage(5)))
            }, _hoisted_39),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setImage(6)))
            }, _hoisted_41),
            _createElementVNode("div", {
              class: "col-6 col-md-4 mb-2",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setImage(7)))
            }, _hoisted_43)
          ])
        ])
      ])
    ])
  ]))
}